import type { AllRouteEndpoints } from "../routeTypes";

export const appsAppGroupIdEncryptionSettings = "/apps/:app_group_id/encryption_settings";
export const appsAppGroupIdEncryptionSettingsCacheKeys: AllRouteEndpoints[] = [];
